import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
/* eslint-disable react-hooks/exhaustive-deps */
export default function useArtistEventChatMobileView(context) {
  const {
    URLSearchParams,
    location,
    selectedEventId,
  } = context;
    // ===== スマホビュー制御（700px以下で一覧⇄チャットをフル画面切替） =====
    const getIsMobile = () => (typeof window !== 'undefined' ? window.innerWidth <= 700 : false);
    const initialMobileView = useMemo(() => {
      if (typeof window === 'undefined') return 'split';
      if (!getIsMobile()) return 'split';
      if (location?.state?.reset) return 'list';
      try {
        const params = new URLSearchParams(location.search || '');
        if (params.get('thread') || params.get('event')) return 'chat';
        const last = sessionStorage.getItem('artist-eventchat:last');
        if (last) {
          const parsed = JSON.parse(last);
          if (parsed?.eventId) return 'chat';
        }
      } catch {}
      return 'list';
    }, [location.search, location.state]);
    const pendingRestoreRef = useRef(initialMobileView === 'chat');
    const [isMobile, setIsMobile] = useState(getIsMobile());
    const [mobileView, setMobileView] = useState(initialMobileView); // 'list' | 'chat' | 'split'
    useLayoutEffect(() => {
      if (typeof window === 'undefined') return;
      const listOnly = isMobile && mobileView === 'list';
      window.dispatchEvent(new CustomEvent('casticart:chat-footer', { detail: { listOnly } }));
    }, [isMobile, mobileView]);
    // モバイルで一覧表示を優先する操作があったか
    const mobileEventListPrefRef = useRef(false);
    // モバイルチャット表示用に pushState 済みか
    const mobileEventChatHistoryRef = useRef(false);


    useEffect(() => {
      const onResize = () => {
        const m = getIsMobile();
        setIsMobile(m);
        if (!m) {
          pendingRestoreRef.current = false;
          setMobileView('split');
          return;
        }

        if (pendingRestoreRef.current && !selectedEventId) {
          setMobileView('chat');
          return;
        }

        if (!selectedEventId) {
          setMobileView('list');
          return;
        }

        setMobileView(mobileEventListPrefRef.current ? 'list' : 'chat');
      };
      onResize();
      window.addEventListener('resize', onResize);
      return () => window.removeEventListener('resize', onResize);
    }, [selectedEventId]); // eslint-disable-line

    useEffect(() => {
      if (!isMobile) return;
      if (pendingRestoreRef.current) return;

      if (!selectedEventId) {
        if (mobileView !== 'list') setMobileView('list');
        return;
      }

      if (mobileView === 'chat' && mobileEventListPrefRef.current) {
        mobileEventListPrefRef.current = false;
        return;
      }

      if (mobileEventListPrefRef.current) {
        if (mobileView !== 'list') setMobileView('list');
      } else if (mobileView !== 'chat') {
        setMobileView('chat');
      }
    }, [isMobile, mobileView, selectedEventId]);

    // モバイルでチャットビューを開いたとき、ブラウザバックで一覧に戻れるように履歴エントリを 1 回だけ追加
    useEffect(() => {
      if (!isMobile) {
        mobileEventChatHistoryRef.current = false;
        return;
      }
      if (
        mobileView === 'chat' &&
        selectedEventId &&
        !mobileEventListPrefRef.current &&
        !mobileEventChatHistoryRef.current
      ) {
        try {
          window.history.pushState({ aecp: 'chat', eventId: selectedEventId }, '');
          mobileEventChatHistoryRef.current = true;
        } catch {
          mobileEventChatHistoryRef.current = false;
        }
      }
    }, [isMobile, mobileView, selectedEventId]);
  return {
    pendingRestoreRef,
    isMobile,
    mobileView,
    setMobileView,
    mobileEventListPrefRef,
    mobileEventChatHistoryRef,
  };
}
